/* ============================================================
   GRACE YEARS - Cart, Engraving, Toast
   Shipping copy: free U.S. shipping on EVERY order (no $ threshold).
   ============================================================ */
(function () {
  'use strict';

  var SHIP_NOTE = 'Free U.S. shipping on every order';

  /* ---- UTILS ---- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ---- TOAST ---- */
  function showToast(msg) {
    let el = qs('.gy-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'gy-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.classList.remove('show'), 2400);
  }

  /* ---- CART DRAWER ---- */
  function openDrawer() {
    qs('.gy-overlay')?.classList.add('is-open');
    qs('.gy-drawer')?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    qs('.gy-overlay')?.classList.remove('is-open');
    qs('.gy-drawer')?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ---- REFRESH CART FROM SHOPIFY AJAX API ---- */
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderItems(cart);
      updateBadge(cart.item_count);
    } catch (e) { /* silent */ }
  }

  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  function setShipNote() {
    const shipEl = qs('.gy-ship-note');
    if (!shipEl) return;
    shipEl.textContent = SHIP_NOTE;
    shipEl.style.color = '';
    shipEl.style.fontWeight = '';
  }

  function renderItems(cart) {
    const itemsEl = qs('.gy-drawer__items');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div class="gy-cart-empty">
          <div class="gy-cart-empty__icon">🛍</div>
          <p>Your bag is empty</p>
          <a href="/collections/all" class="gy-btn gy-btn--primary" style="margin-top:20px" onclick="(function(){document.querySelector('.gy-overlay')?.classList.remove('is-open');document.querySelector('.gy-drawer')?.classList.remove('is-open');document.body.style.overflow=''})()">Start shopping</a>
        </div>`;
      const subtotalEl = qs('.gy-subtotal span:last-child');
      if (subtotalEl) subtotalEl.textContent = fmt(0);
      setShipNote();
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => {
      const engrave = item.properties?.Engraving || item.properties?.engraving || '';
      return `
      <div class="gy-item" data-key="${item.key}">
        <div class="gy-item__thumb">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
        </div>
        <div style="flex:1">
          <div class="gy-item__name">${item.product_title}</div>
          ${engrave ? `<div class="gy-item__engrave">"${engrave}"</div>` : ''}
          <div class="gy-item__row">
            <div class="gy-qty">
              <button data-qty-key="${item.key}" data-delta="-1">−</button>
              <span>${item.quantity}</span>
              <button data-qty-key="${item.key}" data-delta="1">+</button>
            </div>
            <span class="gy-item__price">${fmt(item.line_price)}</span>
            <button class="gy-item__remove" data-remove-key="${item.key}" aria-label="Remove">×</button>
          </div>
        </div>
      </div>`;
    }).join('');

    const subtotalEl = qs('.gy-subtotal span:last-child');
    if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);
    setShipNote();
  }

  function updateBadge(count) {
    qsa('.gy-cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ---- CART AJAX CALLS ---- */
  async function cartAdd(variantId, qty, properties) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: qty || 1, properties }] })
    });
    if (!r.ok) throw new Error(await r.text());
    return r.json();
  }

  async function cartChange(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  /* ---- EVENT DELEGATION ---- */
  document.addEventListener('click', async function (e) {

    if (e.target.closest('.gy-header__cart, [data-gy-open-cart]')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (e.target.closest('.gy-drawer__close, .gy-overlay') && !e.target.closest('.gy-drawer')) {
      closeDrawer();
      return;
    }

    const addBtn = e.target.closest('[data-gy-add]');
    if (addBtn) {
      e.preventDefault();
      const variantId = addBtn.dataset.gyVariantId || addBtn.dataset.gyAdd;
      const engrave = qs('.gy-engraving-input')?.value?.trim() || '';
      const props = engrave ? { 'Engraving': engrave } : {};
      try {
        addBtn.disabled = true;
        await cartAdd(variantId, 1, props);
        showToast('Added to your bag ♡');
        await refreshCart();
        openDrawer();
      } catch (err) {
        showToast('Something went wrong - try again');
      } finally {
        addBtn.disabled = false;
      }
      return;
    }

    const buyBtn = e.target.closest('[data-gy-buy-now]');
    if (buyBtn) {
      e.preventDefault();
      const variantId = buyBtn.dataset.gyBuyNow;
      const engrave = qs('.gy-engraving-input')?.value?.trim() || '';
      const props = engrave ? { 'Engraving': engrave } : {};
      try {
        await cartAdd(variantId, 1, props);
        window.location.href = '/checkout';
      } catch (err) {
        showToast('Something went wrong - try again');
      }
      return;
    }

    const qtyBtn = e.target.closest('[data-qty-key]');
    if (qtyBtn) {
      const key = qtyBtn.dataset.qtyKey;
      const delta = parseInt(qtyBtn.dataset.delta);
      const span = qtyBtn.closest('.gy-qty')?.querySelector('span');
      const cur = parseInt(span?.textContent || 1);
      const next = Math.max(0, cur + delta);
      await cartChange(key, next);
      await refreshCart();
      return;
    }

    const removeBtn = e.target.closest('[data-remove-key]');
    if (removeBtn) {
      await cartChange(removeBtn.dataset.removeKey, 0);
      await refreshCart();
      return;
    }
  });

  /* ---- ENGRAVING COUNTER ---- */
  document.addEventListener('input', function (e) {
    if (e.target.matches('.gy-engraving-input')) {
      const counter = e.target.closest('.gy-engraving__wrap')?.querySelector('.gy-engraving__counter');
      if (counter) counter.textContent = e.target.value.length + '/30';
    }
  });

  /* ---- INIT ---- */
  refreshCart();

})();
